export default class QueryStringHelper {
    setFromQueryString(parameterName, defaultValue, parseFunction) {
        const initialParams = new URLSearchParams(window.location.search);
        if (initialParams.has(parameterName)) {
            const initialValue = initialParams.get(parameterName);
            return parseFunction ? parseFunction(initialValue) : initialValue;
        }
        return defaultValue;
    }
    updateQueryString(value, parameterName) {
        const parameters = new URLSearchParams(window.location.search);
        if (parameters.has(parameterName) && parameters.get(parameterName) === `${value}`) {
            return;
        }
        if (value == null || `${value}` === '') {
            parameters.delete(parameterName);
        }
        else {
            parameters.set(parameterName, `${value}`);
        }
        this.replaceQueryString(parameters);
    }
    updateQueryStrings(parameters) {
        const currentParameters = new URLSearchParams(window.location.search);
        for (const parameter of parameters) {
            if (parameter.value == null || `${parameter.value}` === '') {
                currentParameters.delete(parameter.parameterName);
            }
            else {
                currentParameters.set(parameter.parameterName, `${parameter.value}`);
            }
        }
        const currentQuery = window.location.search;
        const proposedQuery = currentParameters.toString()
            ? `?${currentParameters.toString()}`
            : '';
        if (currentQuery === proposedQuery) {
            return;
        }
        this.replaceQueryString(currentParameters);
    }
    clearQueryString() {
        const parameters = new URLSearchParams(window.location.search);
        parameters.forEach((_value, key) => {
            parameters.delete(key);
        });
        this.replaceQueryString(parameters);
    }
    hasQueryString() {
        return !!window.location.search;
    }
    hasParameter(parameterName) {
        const parameters = new URLSearchParams(window.location.search);
        return parameters.has(parameterName);
    }
    getParameter(parameterName) {
        const parameters = new URLSearchParams(window.location.search);
        return parameters.has(parameterName) ? parameters.get(parameterName) : null;
    }
    replaceQueryString(parameters) {
        const queryString = parameters.toString();
        const url = queryString
            ? `${window.location.pathname}?${queryString}${window.location.hash}`
            : `${window.location.pathname}${window.location.hash}`;
        window.history.replaceState(Object.assign({}, window.history.state), document.title, url);
    }
    getHash(queryString) {
        for (let i = 0, hash = 0; i < queryString.length; i++) {
            hash = (Math.imul(31, hash) + queryString.charCodeAt(i)) | 0;
        }
        return hash;
    }
}
